import { GoogleLogin } from '@react-oauth/google'
import cx from 'classnames'
import { useRef } from 'react'
import Button from 'react-bootstrap/Button'
import FacebookLogin from 'react-facebook-login'
import { useIntl } from 'react-intl'

import Icon from '../../Icon/Icon'
import Typography from '../../Typography/Typography'

import { useContainerDimensions } from './hooks/useContainerDimensions'

import './ButtonSocialLogin.scss'

/**
 * No longer used!!!
 */
const ButtonSocialLogin = ({ variant, onSuccess, onError, ...props }) => {
    const googleWrapperRef = useRef(null)
    const { width: googleWidth } = useContainerDimensions(googleWrapperRef)
    const intl = useIntl()

    const clientFbId = process.env.REACT_APP_FACEBOOK_ID

    const className = cx(
        `button-social d-flex justify-content-center align-items-center w-100 ${
            variant === 'facebook' ? 'bg-blueFacebook' : 'bg-white'
        }`
    )

    if (variant === 'facebook') {
        return (
            <div className="facebook-login-wrapper">
                <FacebookLogin
                    appId={clientFbId}
                    fields="name,email,picture"
                    callback={(resp) => onSuccess(resp)}
                    onFailure={() => onError(variant)}
                    cssClass={'button-social d-flex justify-content-center align-items-center w-100 bg-blueFacebook'}
                    icon={<Icon name={'facebook'} />}
                    scope="public_profile,user_friends,user_actions.books"
                    textButton={
                        <Typography
                            className={'ps-3'}
                            variant={'buttonSocial'}
                            color={variant === 'facebook' ? 'primary' : 'blackTransparent'}
                        >
                            {intl.formatMessage(
                                { id: 'buttons.social' },
                                {
                                    variant,
                                    spanCapitalize: (chunks) => <span className={'text-capitalize'}>{chunks}</span>,
                                }
                            )}
                        </Typography>
                    }
                />
            </div>
        )
    }

    if (variant === 'google') {
        return (
            <div className={'google-login-wrapper'} ref={googleWrapperRef}>
                <GoogleLogin
                    size={'large'}
                    text={'continue_with'}
                    type={'standard'}
                    theme={'outline'}
                    width={googleWidth - 10}
                    logo_alignment={'left'}
                    onError={() => onError(variant)}
                />
            </div>
        )
    }

    return (
        <Button variant="default" className={className} {...props}>
            <Typography
                className={'ps-3'}
                variant={'buttonSocial'}
                color={variant === 'facebook' ? 'primary' : 'blackTransparent'}
            >
                {'Unknown social button variant'}
            </Typography>
        </Button>
    )
}

export default ButtonSocialLogin
